import React from 'react'
import ReactDOM from "react-dom"
import { green_tick_dark, xmarkIcon, close_icon, exclametaryYellowInfoIcon } from '../../../../assets/images'

const removeMessage = (id) => {
  if(id) clearTimeout(id)
  ReactDOM.createRoot(document.getElementById('portal')).unmount()
}

//if want to send custom icon and customer border color then type = 'custom'
const successOrFailureToaster = ({ message = '', type = 'success', customColor = '#F4E3C3', customIcon = exclametaryYellowInfoIcon, width = 'w-96'}) => {
  const icon = { success: green_tick_dark, fail: xmarkIcon, custom: customIcon }
  const border_color = { success: '#008858', fail: '#C80010', custom: customColor }

 const timeout_id = setTimeout(removeMessage, 1000 * 7)  

  const toaster = (
    <div className={`h-20 bg-white rounded-md shadow absolute z-20 right-3 mt-6 p-3 pr-5 flex items-center animate-slide ${width}`}>
      <div className='border-l-4 rounded h-full' style={{ borderColor: border_color[type] }}></div>
      <img src={icon[type]} className='h-6 w-6 ml-4' />
      <div className='w-full ml-4 font-semibold text-gray-700 text-base'>{message}</div>
      <img src={close_icon} className='ml-2 cursor-pointer' onClick={() => removeMessage(timeout_id)}/>
    </div>
  )

  ReactDOM.createRoot(document.getElementById('portal')).render(toaster);
}

export default successOrFailureToaster
